export function BeltBadge({ faixa, compact = false }: { faixa?: string | null; compact?: boolean }) {
  if (!faixa) return null;
  const visual = beltVisual(faixa);
  return <span className={`inline-flex min-w-0 items-center gap-2 ${compact ? "text-[9px]" : "text-[11px]"}`} title={`Faixa ${formatBeltName(faixa)}`}>
    <span
      aria-hidden="true"
      className={`${compact ? "h-2.5 w-8 rounded" : "h-3.5 w-12 rounded-md"} shrink-0 border border-white/20 shadow-[0_2px_8px_rgba(0,0,0,.28)]`}
      style={{ background: visual.background }}
    />
    <span className={`truncate font-bold ${compact ? "text-white/48" : "text-white/70"}`}>{formatBeltName(faixa)}</span>
  </span>;
}

export function BeltAccent({ faixa, className = "" }: { faixa?: string | null; className?: string }) {
  if (!faixa) return null;
  return <span aria-hidden="true" className={`block rounded-full border border-white/20 ${className}`} style={{ background: beltVisual(faixa).background }} />;
}

export function formatBeltName(value: string) {
  const childTip = value.match(/^(Cinza|Amarela|Laranja|Verde)(Branco|Preto)$/);
  if (childTip) return `${childTip[1]} com ponta ${childTip[2] === "Branco" ? "branca" : "preta"}`;
  return value.replace(/([a-záéíóúç])([A-Z])/g, "$1 $2");
}

function beltVisual(faixa: string) {
  const backgrounds: Record<string, string> = {
    Branca: "#f3f4f6",
    CinzaBranco: "linear-gradient(90deg,#737b84 0 36%,#f3f4f6 36% 64%,#737b84 64% 100%)",
    Cinza: "#737b84",
    CinzaPreto: "linear-gradient(90deg,#737b84 0 36%,#111827 36% 64%,#737b84 64% 100%)",
    AmarelaBranco: "linear-gradient(90deg,#e8b923 0 36%,#f3f4f6 36% 64%,#e8b923 64% 100%)",
    Amarela: "#e8b923",
    AmarelaPreto: "linear-gradient(90deg,#e8b923 0 36%,#111827 36% 64%,#e8b923 64% 100%)",
    LaranjaBranco: "linear-gradient(90deg,#e97921 0 36%,#f3f4f6 36% 64%,#e97921 64% 100%)",
    Laranja: "#e97921",
    LaranjaPreto: "linear-gradient(90deg,#e97921 0 36%,#111827 36% 64%,#e97921 64% 100%)",
    VerdeBranco: "linear-gradient(90deg,#268757 0 36%,#f3f4f6 36% 64%,#268757 64% 100%)",
    Verde: "#268757",
    VerdePreto: "linear-gradient(90deg,#268757 0 36%,#111827 36% 64%,#268757 64% 100%)",
    Azul: "#245ca8",
    Roxa: "#6f42a8",
    Marrom: "#70412f",
    Preta: "linear-gradient(90deg,#111827 0 78%,#a12424 78% 100%)",
  };
  return { background: backgrounds[faixa] ?? "#737b84" };
}
